import React, { Component } from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

class AmPie extends Component {
  componentDidMount() {
    // Create chart instance
    let chart = am4core.create("chartdiv", am4charts.PieChart);

    //chart.paddingRight = 20;

    // Add data
    chart.data = this.props.data;    

    // Add and configure Series
    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "y";
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;

    // Add color
    let colorSet = new am4core.ColorSet();
    colorSet.list = ["#FBC02D", "#388E3C"].map(function(color) {
        return new am4core.color(color);
    });
    pieSeries.colors = colorSet;

    chart.legend = new am4charts.Legend(); 
    this.chart = chart;
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  render() {
    return (
      <div id="chartdiv" style={{ width: "100%", height: "400px" }}></div>
    );
  }
}

export default AmPie;